import { connect } from 'react-redux';
import { Header } from 'components/HeaderTnC';

const mapStateToProps = state => {
  return {};
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
